<sc-flex fitHeight stretchContent vertical>
  <form [formGroup]="formGroup">
    <sc-flex >
      <span>
        <sc-dictionary-label dictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.members.add.label"></sc-dictionary-label>
      </span>
      <sc-content-spacer></sc-content-spacer>
      <sc-string-field formControlName="firstName" [required]="true" labelDictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.members.add.firstname">
      </sc-string-field>
      <sc-content-spacer></sc-content-spacer>
      <sc-string-field formControlName="name" [required]="true" labelDictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.members.add.name">
      </sc-string-field>
      <sc-content-spacer></sc-content-spacer>
      <sc-add-button (click)="addMember()" [disabled]="!formGroup.valid"></sc-add-button>
    </sc-flex>
  </form>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      <table mat-table [dataSource]="membersDataSource" style="width: 100%;">

        <ng-container matColumnDef="hint">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.possibleDuplicate" title="Besucher wurde bereits erfasst"><i
                class="far fa-exclamation-triangle"></i></div>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.members.table.col.name"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="firstname">
          <th mat-header-cell *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.members.table.col.firstname"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.firstname}} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element;let i = index">
            <a class="action" (click)="deleteMember(i)">
              <sc-icon iconClass="fa-trash"></sc-icon>
            </a>
          </td>
        </ng-container>
        <ng-container matColumnDef="filler" style="flex-grow: 100;">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element;let i = index">
            &nbsp;
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="this.membersTableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: this.membersTableColumns;"></tr>

      </table>
      <div *ngIf="!(visit?.members?.length !== 0)">
        <sc-padding>
          <sc-flex [centered]="true">
            <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
          </sc-flex>
        </sc-padding>
      </div>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
</sc-flex>
